module.exports = __webpack_public_path__ + "static/sheepsuitcase-abd40e2b3ef86ce752e2e61bd5ab779d.jpeg";